export const hostSystemScenario = {
  DMC: 'DMC',
  EXPERT: 'Expert',
};

